export enum SalesItemTraitsEnum {
    Send_PrescriptionsToRX = 1,
    BlockUsersFromManuallyAddingToVisit,
    DisallowRemovalFromVisit,
    HeartwormProtection,
    FleaTickProtection,
    AllowDecline,
    MinimumWeight,
    MaximumWeight,
    IDEXXHeadlessOrder,
    IDEXXOrder,
    ReservationPreConfirmed,
    ReservationOverbooked,
    ReservationWalkIn,
    SendLabResultsToPetParent,
    IDEXXInHouseTest,
    IsEuthanasia,
    IsSpayNeuter,
    IsControlled,
    BarcodeNotRequired,
    IsAnesthesiaMedication,
    IncludeInWellnessSummary,
    AllowedInPnpNewOrder,
    AllowVisitSalesItemOptionUpdates
}
